import { FETCH_PROFILE_DETAILS, FETCH_PROFILE_DETAILS_SUCCESS, FETCH_PROFILE_DETAILS_FAILURE,ONCHANE_PROFILE_DETAILS,
UPDATE_PROFILE,
UPDATE_PROFILE_SUCCESS,
UPDATE_PROFILE_FAILURE,
UPDATE_PROFILE_PHOTO,
UPDATE_PROFILE_PHOTO_SUCCESS,UPDATE_PROFILE_PHOTO_FAILURE, DELETE_PROFILE_PHOTO, DELETE_PROFILE_PHOTO_SUCCESS, DELETE_PROFILE_PHOTO_FAILURE} from "./ProfileAction";
    const defaultState= {
        isLoading: false,
        profileData: {}
    }
    const ProfileSettingReducer = (state = defaultState,action) => {
        switch(action.type) {
            case FETCH_PROFILE_DETAILS:
                return { ...state,isLoading:true};
            case FETCH_PROFILE_DETAILS_SUCCESS:
                return {...state, profileData: action.payload,isLoading:false };
            case FETCH_PROFILE_DETAILS_FAILURE:
                return {...state, isLoading: false };
            case ONCHANE_PROFILE_DETAILS :
                return {...state, profileData:{...state.profileData, ...action.payload} };
            case UPDATE_PROFILE:
                return {...state, isLoading: true};
            case UPDATE_PROFILE_SUCCESS:
                return {...state, isLoading: false };
            case UPDATE_PROFILE_FAILURE:
                return {...state, isLoading: false };
            case UPDATE_PROFILE_PHOTO:
                    return { ...state, isLoading: true };
                    case UPDATE_PROFILE_PHOTO_SUCCESS:
                        return {
                            ...state,
                            isLoading: false,
                            profileData: {
                                ...state.profileData,
                                profilePhoto: action.payload,
                            },
                        };
            case UPDATE_PROFILE_PHOTO_FAILURE:
                    return { ...state, isLoading: false };
            case DELETE_PROFILE_PHOTO:
                return { ...state, isLoading: true};
            case DELETE_PROFILE_PHOTO_SUCCESS:
                return {
                    ...state,
                    isLoading: false,
                    profileData: {
                        ...state.profileData,
                        profilePhoto: null,
                    }, // Reset profile photo URL to null after successful deletion
                };
            case DELETE_PROFILE_PHOTO_FAILURE:
                return {...state, isLoading: false};
            default:
                return state;
        }
    }
    export default ProfileSettingReducer;
